import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const environment = (import.meta.env.VITE_SENTRY_ENVIRONMENT as string) ||
  (import.meta.env.PROD ? "production" : "development");

export function initSentry() {
  if (!dsn) {
    console.warn("[sentry] VITE_SENTRY_DSN not set — error tracking disabled");
    return;
  }

  Sentry.init({
    dsn,
    environment,
    release: (import.meta.env.VITE_SENTRY_RELEASE as string) || undefined,
    enabled: !!dsn,
  });
}

export function setSentryUser(context: { parentId?: string; childId?: string }) {
  Sentry.setUser(context.parentId ? { id: context.parentId, segment: context.childId } : null);
}

export { Sentry };
